/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllowedSaveToTableDto } from '../models/AllowedSaveToTableDto';
import type { AvailableColumnDto } from '../models/AvailableColumnDto';
import type { AvailableTableDto } from '../models/AvailableTableDto';
import type { CreateAllowedSaveToTableRequest } from '../models/CreateAllowedSaveToTableRequest';
import type { UpdateAllowedSaveToTableRequest } from '../models/UpdateAllowedSaveToTableRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SaveToTableAdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all allowed SaveToTable entries for the current organization.
     * @param orgGuid
     * @returns AllowedSaveToTableDto OK
     * @throws ApiError
     */
    public getApiSaveToTableAdmin(
        orgGuid: string,
    ): CancelablePromise<Array<AllowedSaveToTableDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SaveToTableAdmin/{orgGuid}',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new allowed SaveToTable entry.
     * @param orgGuid
     * @param sysOrgGuid
     * @param requestBody
     * @returns AllowedSaveToTableDto OK
     * @throws ApiError
     */
    public postApiSaveToTableAdmin(
        orgGuid: string,
        sysOrgGuid?: string,
        requestBody?: CreateAllowedSaveToTableRequest,
    ): CancelablePromise<AllowedSaveToTableDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/SaveToTableAdmin/{orgGuid}',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'sysOrgGuid': sysOrgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an allowed SaveToTable entry (display label and description only).
     * @param sysOrgGuid
     * @param entryGuid
     * @param requestBody
     * @returns AllowedSaveToTableDto OK
     * @throws ApiError
     */
    public putApiSaveToTableAdmin(
        sysOrgGuid: string,
        entryGuid: string,
        requestBody?: UpdateAllowedSaveToTableRequest,
    ): CancelablePromise<AllowedSaveToTableDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/SaveToTableAdmin/{sysOrgGuid}/{entryGuid}',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'entryGuid': entryGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an allowed SaveToTable entry.
     * @param sysOrgGuid
     * @param entryGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteApiSaveToTableAdmin(
        sysOrgGuid: string,
        entryGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/SaveToTableAdmin/{sysOrgGuid}/{entryGuid}',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'entryGuid': entryGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all available tables that can be configured for SaveToTable.
     * These are the tables registered in the SaveToTableRegistry.
     * @param sysOrgGuid
     * @returns AvailableTableDto OK
     * @throws ApiError
     */
    public getApiSaveToTableAdminAvailableTables(
        sysOrgGuid: string,
    ): CancelablePromise<Array<AvailableTableDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SaveToTableAdmin/{sysOrgGuid}/available-tables',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all available columns for a specific table that can be configured for SaveToTable.
     * These are the columns registered in the SaveToTableRegistry.
     * @param sysOrgGuid
     * @param tableName
     * @returns AvailableColumnDto OK
     * @throws ApiError
     */
    public getApiSaveToTableAdminAvailableTablesColumns(
        sysOrgGuid: string,
        tableName: string,
    ): CancelablePromise<Array<AvailableColumnDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SaveToTableAdmin/{sysOrgGuid}/available-tables/{tableName}/columns',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'tableName': tableName,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
